
/**
* @component Content
*
* Center content within supported breakpoints.
*
* @note we could add maximum breakpoints prop
*
* @public
*/

export default {
  name: 'ContentComponent',
};
